import { InferGetStaticPropsType } from 'next';
import Image from 'next/image';

import { hnaviShortTitle, hnaviTitle } from '@constants';
import { Layout2, SideContents, LinkBracket } from '@components';
import NotFound from '@images/404.png';
import { isrRevalidateSec } from '@constants';
import { getHnaviOptions } from '@api';

const Custom404: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = ({
  hnaviOptions,
}) => {
  return (
    <Layout2
      useHnaviHeader
      breadcrumbs={[
        { text: hnaviTitle, shortText: hnaviShortTitle, url: '/' },
        { text: 'ページが見つかりませんでした' },
      ]}
      sideBar={<SideContents fixedBanner={hnaviOptions.banners.buyerFixed} />}
    >
      <Image
        src={NotFound.src}
        width={NotFound.width}
        height={NotFound.height}
        className='mx-auto max-w-full'
        alt='404'
      />
      <div className='mb-6 text-center'>
        <a
          href='/'
          className='inline-flex items-center gap-2 rounded-full border border-top-primary py-3 px-6 font-bold text-top-primary transition-opacity hover:opacity-75'
        >
          TOPへ戻る
          <LinkBracket className='mt-[1px]' />
        </a>
      </div>
    </Layout2>
  );
};

export const getStaticProps = async () => {
  console.info(`getStaticProps: the 404 page`);
  return {
    props: { hnaviOptions: await getHnaviOptions() },
    revalidate: isrRevalidateSec,
  };
};

export default Custom404;
